module.exports = __webpack_public_path__ + "static/media/riverfolk.3685bcbd.jpg";